module.exports = "/_next/static/images/bca4b9917cc7c2a9835e6afbb4ff526f-apple-pay-xs.png";